// removed by extract-text-webpack-plugin
module.exports = {"userEligibilityContainer":"userEligibilityContainer__3Y2zI","headingTextContainer":"headingTextContainer__1DeBT","userEligibilityTextContainer":"userEligibilityTextContainer__Gsm82","textContainer":"textContainer__3ZlbY","cardlessEmiText":"cardlessEmiText__20YKL","subText":"subText__RaHES","logoImage":"logoImage__2y9Eq","logoContainer":"logoContainer__yXuI0"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/nonApprovedUserCard/nonApprovedContainer/style.css
// module id = 03nk
// module chunks = 323